import { MDBIcon } from 'mdb-react-ui-kit';
import React, { useContext } from 'react';
import useResumeExperiencesHandlers from "../../../context/resume/hooks/resume-experiences-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../../hooks/useCurrentUserRoles";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import { calculateDatesDifference } from "../../../utils/calculateDatesDifference";
import { parseISO } from 'date-fns';

function ExperiencesPreview() {

    const { translations, displayLanguage, formatDate } = useContext( TranslationContext );
    const { isAlcyone, isEuropass, isAnonymous, isExperienceHidden } = useResumeProperties();
    const { experiences } = useResumeDocumentSection();
    const { isManagerRole } = useCurrentUserRoles();
    const { handleRemove } = useResumeExperiencesHandlers();

    function difference( from, to ) {
        const { years, months } = calculateDatesDifference( from, to );
        let str = '';
        if ( years > 0 ) {
            str += `${ years } ${ years > 1 ? translations.general.years : translations.general.year }`;
        }
        if ( months > 0 && years > 0 ) {
            str += ` ${ translations.general.and } `
        }
        if ( months > 0 ) {
            str += `${ months } ${ months > 1 ? translations.general.months : translations.general.month }`
        }
        return str;
    }

    if ( isExperienceHidden ) {
        return null;
    }

    return (
        <>
            { experiences
                ?.sort((a, b) => parseISO(b?.from) - parseISO(a?.from))
                .map( ( experience, index ) => {
                const technicalEnvironment = experience?.technicalEnvironment || experience?.technicalEnvironments || [];
                const technicalEnvironmentLabels = Array.isArray( technicalEnvironment )
                    ? technicalEnvironment
                        .map( ( skill ) => {
                            if ( typeof skill === "string" ) {
                                return skill;
                            }
                            return skill?.translations?.[ displayLanguage ] || skill?.name || '';
                        } )
                        .filter( Boolean )
                    : [];
                const employerText = isAnonymous
                    ? translations.pdf.employerLabel
                    : ( experience?.employer?.trim?.() ? experience.employer : "" );
                const missionDays = experience?.duration
                    ?? experience?.numberOfMissionDays
                    ?? experience?.jourMission
                    ?? experience?.jourGlobal;
                const hasMissionDays = missionDays !== null && missionDays !== undefined && missionDays !== '';
                return (
                <React.Fragment key={ index }>
                    { experience && experience.employer && (
                        <>
                            { isManagerRole && (
                                <MDBIcon
                                    far
                                    icon="trash-alt"
                                    style={ {
                                        color: isAlcyone ? "#09B4BF" : "#0B86C8",
                                        fontSize: "11px",
                                        marginLeft: "-30px",
                                        fontWeight: 'bold'
                                    } }
                                    onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemove( experience ) }
                                    role="button"
                                    size="lg"
                                />
                            ) }
                        </>
                    ) }
                    <div className="d-flex no-page-break" style={ { marginTop: isManagerRole ? '-20px' : '0' } }>
                        { !isEuropass && (
                            <div style={ { width: '15%', marginRight: '10px' } }>
                                <p className="fw-bold mb-0 text-black" style={ { fontSize: "12px" } }>
                                    { isAnonymous
                                        ? translations.pdf.employerLabel
                                        : experience.employer }
                                </p>
                                { experience.activitySector?.translations?.[ displayLanguage ] && (
                                    <p className="mb-0 text-black" style={ { fontSize: "11px" } }>
                                        { experience.activitySector.translations[ displayLanguage ] }
                                    </p>
                                ) }
                                <p className="mb-0 text-black"
                                   style={ { color: "#09B4BF", fontSize: "11px" } }>
                                    { experience.location }
                                </p>
                                <p className="text-black" style={ { fontSize: "11px" } }>
                                    { experience.from && ( experience.to || experience.isCurrent )
                                        ? (
                                            <>
                                             <span
                                                 style={ { fontSize: isEuropass && "9px" } }
                                             >
                                                 { experience.from
                                                     ? formatDate( experience.from )
                                                     : ''
                                                 }
                                                 { ' - ' }
                                                 { experience.isCurrent
                                                     ? translations.general.now
                                                     : ( experience.to
                                                         ? formatDate( experience.to )
                                                         : '' )
                                                 }
                                             </span><br/>
                                                <span>
                                                 { difference( experience.from, experience.isCurrent ? null
                                                     : experience.to ) }
                                             </span>
                                            </>
                                        ) : experience.from ? (
                                            <span>{ formatDate( experience.from ) }</span>
                                        ) : experience.to ? (
                                            <span>{ formatDate( experience.to ) }</span>
                                        ) : null }
                                </p>
                            </div>
                        ) }
                        <div
                            className={ !isEuropass ? "w-75" : "w-100" }
                            style={ { fontSize: "12px", textAlign: "justify" } }
                        >
                            { isEuropass && (
                                <p style={ { fontSize: "11px", marginBottom: "0px" } }>
                                    { experience.from && ( experience.to || experience.isCurrent )
                                        ? (
                                            <div>
                                            <span style={ {
                                                 fontSize: isEuropass && "9px",
                                                 textTransform: "uppercase"
                                             } }>
                                                 { experience.from
                                                     ? formatDate( experience.from ) : '' }
                                                 { ' - ' }
                                                 { experience.isCurrent
                                                     ? translations.pdf.isCurrentLabel
                                                     : ( experience.to
                                                         ? formatDate( experience.to ) : '' ) }
                                                 { hasMissionDays && (
                                                     <>
                                                         { ' ' }( { missionDays } j/h )
                                                     </>
                                                 ) }
                                             </span>
                                            </div>
                                        ) : experience.to ? (
                                            <span>{ formatDate( experience.from ) }</span>
                                        ) : experience.from ? (
                                            <span>{ formatDate( experience.to ) }</span>
                                        ) : null }
                                </p>
                            ) }
                            { !isEuropass ? (
                                <span className="fw-bold" style={ {
                                    color: isAlcyone ? "#09B4BF" : "#0B86C8"
                                } }>
                                    { experience.jobPosition }
                                </span>
                            ) : (
                                <span style={ { color: "#404040", textTransform: "uppercase" } }>
                                     <strong>
                                         { experience.jobPosition }{ ' ' }
                                         { experience.isConsultingMission && ` ( ${ translations.pdf.isConsultingLabel } ${ experience.client } )` }
                                     </strong>
                                    { employerText && (
                                        <>
                                            { ' - ' }
                                            { employerText }
                                        </>
                                    ) }
                                 </span>
                            ) }
                            { isEuropass && (
                                <hr style={ {
                                    color: "#979797",
                                    height: "2px",
                                    width: "100%",
                                    marginLeft: "0px",
                                    marginBottom: "20px",
                                    marginTop: "4px"
                                } }/>
                            ) }
                            { !isEuropass && experience.isConsultingMission && experience.client && (
                                <span className="fw-bold text-black">
                                    { ' - ' }
                                    { translations.pdf.isConsultingLabel }{ ' ' }
                                    { isAnonymous ? 'Client' : experience.client }
                                </span>
                            ) }
                            { !isEuropass && experience.contractType && (
                                <p className="fw-bold mb-0">{ experience.contractType?.translations?.[ displayLanguage ] }</p>
                            ) }
                            <div>
                                { experience.roles && experience.roles.length > 0 && (
                                    <>
                                        { !isEuropass ? (
                                            <span style={ {
                                                color: isAlcyone ? "#09B4BF" : "#0B86C8"
                                            } }>
                                                { translations.pdf.rolesLabel }
                                            </span>
                                        ) : (
                                            <p className="fw-bold mb-0" style={ { textDecoration: "underline" } }>
                                                { translations.pdf.rolesLabel }
                                            </p>
                                        ) }
                                        <ul className="mb-0 text-black">
                                            { experience.roles
                                                .map( ( role, index ) =>
                                                    <li key={ index }>{ role.text }</li>
                                                ) }
                                        </ul>
                                    </>
                                ) }
                            </div>
                            <div>
                                { experience.context ? (
                                    <>
                                        { !isEuropass && (
                                            <span style={ { color: isAlcyone ? "#09B4BF" : "#0B86C8" } }>
                                                { translations.pdf.contextLabel }
                                            </span>
                                        ) }
                                        { isEuropass && (
                                            <p className="fw-bold mb-0" style={ { textDecoration: "underline" } }>
                                                { translations.pdf.contextLabel }
                                            </p>
                                        ) }
                                        <p className={ isEuropass ? " mt-2" : "mb-0 text-black" }
                                           style={ isEuropass ? { fontSize: "9px" } : null }>
                                            { experience.context }
                                        </p>
                                    </>
                                ) : null }
                            </div>
                            <div>
                                { experience.achievement ? (
                                    <>
                                        { !isEuropass && (
                                            <span style={ { color: isAlcyone ? "#09B4BF" : "#0B86C8" } }>
                                                { translations.pdf.achievementsLabel }
                                            </span>
                                        ) }
                                        { isEuropass && (
                                            <p className="fw-bold mb-0" style={ { textDecoration: "underline" } }>
                                                { translations.pdf.achievementsLabel }
                                            </p>
                                        ) }
                                        <p className={ isEuropass ? " mt-2" : "mb-0 text-black" }
                                           style={ isEuropass ? { fontSize: "9px", whiteSpace: "pre-line" } : { whiteSpace: "pre-line" } }>
                                            { experience.achievement }
                                        </p>
                                    </>
                                ) : null }
                            </div>
                            { isEuropass && experience.actions && experience.actions.length > 0 && (
                                <div className="mb-2">
                                    <p className="fw-bold mb-0" style={ { textDecoration: "underline" } }>
                                        { translations.pdf.actionsLabel }
                                    </p>
                                    <ul className="mb-0 text-black">
                                        { experience.actions
                                            .map( ( action, actionIndex ) =>
                                                <li key={ actionIndex }>{ action.text }</li> ) }
                                    </ul>
                                </div>
                            ) }
                            { !isEuropass && experience && experience.actions && experience.actions.length > 0 && (
                                <>
                                    { isEuropass ? (
                                        <p className="fw-bold mb-0"
                                           style={ { textDecoration: "underline" } }>
                                            { translations.pdf.actionsLabel }
                                        </p>
                                    ) : (
                                        <p className="mb-0" style={ {
                                            color: isAlcyone ? "#09B4BF" : "#0B86C8"
                                        } }>
                                            { translations.pdf.actionsLabel }
                                        </p>
                                    ) }
                                    <ul className="mb-0 text-black">
                                        { experience.actions
                                            .map( ( action, actionIndex ) =>
                                                <li key={ actionIndex }>{ action.text }</li>
                                            ) }
                                    </ul>
                                </>
                            ) }
                            { technicalEnvironmentLabels.length > 0
                                && (
                                <div className="mt-0">
                                    { !isEuropass ? (
                                        <span style={ {
                                            color: isAlcyone ? "#09B4BF" : "#0B86C8"
                                        } }>
                                            { translations.pdf.technicalEnvironmentLabel }
                                        </span>
                                    ) : (
                                        <>
                                            <span className="fw-bold mb-0"
                                                  style={ { textDecoration: "underline" } }>
                                                { translations.pdf.technicalEnvironmentLabel }
                                            </span>
                                        </>
                                    ) }
                                    { !isEuropass && (
                                        <p className="text-black">
                                            { ' ' + technicalEnvironmentLabels.join( ", " ) }
                                        </p>
                                    ) }
                                    { isEuropass && (
                                        <p style={ { fontSize: "9px" } }>
                                            { ' ' + technicalEnvironmentLabels.join( ", " ) }
                                        </p>
                                    ) }
                                </div>
                            ) }
                        </div>
                    </div>
                    { index < experiences.length - 1 && (
                        <hr style={ { color: isAlcyone ? "#09B4BF" : "#0B86C8" } }/> ) }
                </React.Fragment>
                );
            } ) }
        </>
    );
}

export default React.memo( ExperiencesPreview );
